module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-108.0789301.woff2";